<div class="container my-3">
  <!-- <h1 class="mb-3">Edit User</h1> -->
  <form #form="ngForm" (ngSubmit)="UpdateUser()" class="mt-4">
    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="roleId" class="form-label">Company</label>
      </div>
      <div class="col-sm-4">
        <select
          class="form-select border border-dark"
          [(ngModel)]="userDetails.CompanyId"
          name="CompanyId"
          id="CompanyId"
        >
          <option value="0" selected>Choose Company</option>
          <option
            *ngFor="let company of companies"
            value="{{ company.Id }}"
            selected
          >
            {{ company.Name }}
          </option>
        </select>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="name" class="form-label">Account Type</label>
      </div>
      <div class="col-sm-4">
        <select
          class="form-select border border-dark"
          [(ngModel)]="userDetails.RoleId"
          name="RoleId"
        >
          <option
            *ngFor="let role of roles"
            [value]="role.Id"
            [selected]="role.Id === userDetails.RoleId"
          >
            {{ role.Name }}
          </option>
        </select>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="AccountStatus" class="form-label">Account Status:</label>
      </div>
      <div class="col-sm-4">
        <select
          class="form-select border border-dark"
          name="AccountStatus"
          id="AccountStatus"
          [(ngModel)]="selectedStatus"
        >
          <option *ngFor="let access of accesses" [ngValue]="access.Id">
            {{ access.Name }}
          </option>
        </select>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="firstName" class="form-label">First Name</label>
      </div>
      <div class="col-sm-4">
        <input
          type="text"
          class="form-control border border-dark"
          id="firstName"
          name="firstName"
          [(ngModel)]="userDetails.FirstName"
        />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="lastName" class="form-label">Last Name</label>
      </div>
      <div class="col-sm-4">
        <input
          type="text"
          class="form-control border border-dark"
          id="lastName"
          name="lastName"
          [(ngModel)]="userDetails.LastName"
        />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="email" class="form-label">Email</label>
      </div>
      <div class="col-sm-4">
        <input
          type="email"
          class="form-control border border-dark"
          id="email"
          name="email"
          [(ngModel)]="userDetails.Email"
        />
      </div>
    </div>

    <!-- <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="PhoneNumber" class="form-label">Phone Number</label>
      </div>
      <div class="col-sm-4">
        <input
          type="number"
          class="form-control border border-dark"
          id="PhoneNumber"
          name="PhoneNumber"
          [(ngModel)]="userDetails.PhoneNumber"
        />
      </div>
    </div> -->

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="username" class="form-label">Username</label>
      </div>
      <div class="col-sm-4">
        <input
          type="text"
          class="form-control border border-dark"
          id="username"
          name="username"
          [(ngModel)]="userDetails.UserName"
        />
      </div>
    </div>

    <!-- <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="password" class="form-label">Password</label>
      </div>
      <div class="col-sm-4">
        <input
          type="password"
          class="form-control border border-dark"
          id="password"
          name="password"
          [(ngModel)]="userDetails.Password"
        />
      </div>
    </div> -->
    <!-- <div class="mb-3">
            <label for="type" class="form-label">Type</label>
            <input type="text" class="form-control border border-dark" id="type" name="type"
              [(ngModel)]="userDetails.Type" />
          </div> -->
    <!-- <div class="mb-3">
            <label for="RoleName" class="form-label">Role Name</label>
            <input type="text" class="form-control border border-dark" id="RoleName" name="RoleName"
              [(ngModel)]="userDetails.RoleName" />
          </div> -->
    <!-- <div class="mb-3">
            <label for="region" class="form-label">region</label>
            <input type="text" class="form-control border border-dark" id="region" name="region"
              [(ngModel)]="userDetails.region" />
          </div> -->
    <div style="min-height: 70px"></div>
    <div class="row">
      <div class="col-sm-2" style="text-align: right">
        <button type="submit" class="btn custom-buttons-btn m-3">Update</button>
      </div>
      <div class="col-sm-2" style="text-align: left" *ngIf="this.userDetails.IsLockedOut === false && this.userDetails.ActionType === 'I'">
        <!-- <button type="button"class="btn btn-danger m-3"(click)="deleteUser(userDetails.UserId)">Delete</button> -->
        <button
          type="button"
          class="btn custom-buttons-btn m-3"
          (click)="Disable(userDetails.UserId)"
          
        >
          Disable
        </button>
      </div>
      <div class="col-sm-2" style="text-align: left" *ngIf="(this.userDetails.IsLockedOut === true && this.userDetails.ActionType === 'I')|| (this.userDetails.IsLockedOut === false && this.userDetails.ActionType === 'F')">
        <button
          type="button"
          class="btn custom-buttons-btn m-3"
          (click)="Enable(userDetails.UserId)"
          
        >
          Activate
        </button>
      </div>
      <div style="min-height: 30px"></div>
    </div>
  </form>
</div>
